import { effect, inject, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { resolveDateFormatProfile } from '@shared-ui-kit';
import { CoreService } from '@core-session';

/**
 * Keeps the Material `DateAdapter` on the same locale as the pickers.
 *
 * Every `mat-calendar` in the app — the new picker's panel included — takes its month
 * and weekday names from the adapter, and the date-fns adapter needs a real date-fns
 * `Locale` object to do it. Instantiating this service is what starts the sync; the
 * apps do that from their root component.
 */
@Injectable({ providedIn: 'root' })
export class DateLocaleService {
  private readonly dateAdapter = inject<DateAdapter<Date>>(DateAdapter);
  private readonly coreService = inject(CoreService);

  constructor() {
    effect(() => {
      const profile = resolveDateFormatProfile(this.coreService.getUserLocale());
      this.dateAdapter.setLocale(profile.dateFns);
    });
  }
}
